import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	resizeKeyboardShortcutLabel: {
		id: 'software-releases-version-detail.right-sidebar.resize-keyboard-shortcut-label',
		defaultMessage:
			'Keyboard shortcut "]" which used to expand and collapse version details right sidebar',
		description:
			'Label for the keyboard shortcut used to expand and collapse the version details right sidebar',
	},
});
